export const FUNCTION_NAME_REGEX = /[A-Za-z_]+/

export const FIELD_NAME_REGEX = /\{[^{}]+}/
